import React from "react";
import { FormControl, FormItem, FormLabel, FormMessage } from "../../../../components/ui/form";
import { Input } from "../../../../components/ui/input";
import { Button } from "../../../../components/ui/button";
import { Cross2Icon } from "@radix-ui/react-icons";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  SelectSeparator,
} from "../../../../components/ui/select";

interface CategorySelectProps {
  field: any;
  FormField: any;
}

export function CategorySelect({ field }: CategorySelectProps) {
  const [isAddingNew, setIsAddingNew] = React.useState(false);
  const [newCategory, setNewCategory] = React.useState("");

  const handleNewCategory = () => {
    if (newCategory.trim()) {
      field.onChange(newCategory.trim());
      setIsAddingNew(false);
      setNewCategory("");
    }
  };

  if (isAddingNew) {
    return (
      <FormItem className="space-y-1">
        <FormLabel>New Category</FormLabel>
        <div className="flex gap-2">
          <FormControl>
            <Input
              value={newCategory}
              onChange={(e) => setNewCategory(e.target.value)}
              placeholder="Enter category name"
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault();
                  handleNewCategory();
                } else if (e.key === 'Escape') {
                  setIsAddingNew(false);
                  setNewCategory("");
                }
              }}
            />
          </FormControl>
          <Button
            type="button"
            variant="outline"
            size="icon"
            onClick={() => {
              setIsAddingNew(false);
              setNewCategory("");
            }}
          >
            <Cross2Icon className="h-4 w-4" />
          </Button>
        </div>
        <p className="text-xs text-muted-foreground">
          Press Enter to save or X to cancel
        </p>
        <FormMessage />
      </FormItem>
    );
  }

  return (
    <FormItem>
      <FormLabel>Category</FormLabel>
      <Select
        onValueChange={(value) => {
          if (value === "new") {
            setIsAddingNew(true);
          } else {
            field.onChange(value);
          }
        }}
        value={field.value}
      >
        <FormControl>
          <SelectTrigger>
            <SelectValue placeholder="Select category" />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          <SelectItem value="ppe">PPE</SelectItem>
          <SelectItem value="medications">Medications</SelectItem>
          <SelectItem value="supplies">Medical Supplies</SelectItem>
          <SelectSeparator />
          <SelectItem value="new" className="text-primary">
            + Create new category
          </SelectItem>
        </SelectContent>
      </Select>
      <FormMessage />
    </FormItem>
  );
}
